import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { EWorldMapSetType } from '__generated__/globalTypes';
import { EColors, EFonts, EGrads, EHovers } from 'libs/styles/styling';
import { sortBy } from 'lodash';
import { useContext } from 'react';
import { CtxView } from 'session/ctxView';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const CustomMapFloors = (props: Props) => {
    const ctxView = useContext(CtxView);

    const floors = sortBy(
        ctxView.map?.worldMapSets?.filter((e) => e.type === EWorldMapSetType.FLOOR) ?? [],
        (e) => e.orderIndex
    );

    if (!floors || !floors.length) {
        return null;
    }

    const floorIds = floors.map((e) => e.worldMapSetId);

    function changeFloor(floorId: string) {
        const visibleIdsWithoutFloor = ctxView.visibleMapSetIds.filter(
            (e) => !floorIds.includes(e)
        );

        ctxView.setVisibleMapSetIds([...visibleIdsWithoutFloor, floorId]);
    }

    return (
        <S_CustomMapFloors className={props.className}>
            <S_FloorButtons>
                {floors.map((e) => {
                    return (
                        <S_Floor
                            key={e.worldMapSetId}
                            $selected={ctxView.visibleMapSetIds.includes(e.worldMapSetId)}
                            onClick={() => changeFloor(e.worldMapSetId)}
                        >
                            <S_Icon icon={['fal', 'layer-group']} />
                            {e.title}
                        </S_Floor>
                    );
                })}
            </S_FloorButtons>
        </S_CustomMapFloors>
    );
};

const S_CustomMapFloors = styled.div``;

const S_FloorButtons = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex: 1;
`;

const S_Icon = styled(FontAwesomeIcon)`
    font-size: 13px;
    margin-right: 10px;
`;

const S_Floor = styled.div<{ $selected: boolean }>`
    height: 35px;
    display: flex;
    align-items: center;
    color: #141c54;
    font-size: 13px;
    padding: 5px 12px;
    border-radius: 100px;
    cursor: pointer;
    font-family: ${EFonts.Regular};
    box-shadow: ${EHovers.LIGHT1};
    &:hover {
        background-color: ${EColors.GREY5};
    }
    ${(props) => {
        if (props.$selected) {
            return `
            color: ${EColors.WHITE};
            background: ${EGrads.ACC2_GRAD};
            `;
        } else {
            return `
        background-color: #fff;
        `;
        }
    }}
`;
